import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import {inject, observer} from "mobx-react";

import { AxlButton, AxlInput, AxlPanel, AxlCheckbox, AxlTextArea, AxlSelect, AxlDateInput } from 'axl-reactjs-ui';

// styles
import styles, * as E from '../../styles';

import {downloadPdf} from '../../../../utils/pdf';

@inject("shipmentStore")
@observer
class SingleOrderSubmitted extends React.Component {
  downloadLabel = (e) => {
    const { activeShipment, shipmentStore } = this.props;
    downloadPdf(shipmentStore, activeShipment.id, 'PDF');
  }

  render() {
    const { activeShipment } = this.props;

    return (<E.StepContainer>
        <E.Panel>
          <E.PanelTitle>{`Shipment Information`}</E.PanelTitle>
          <E.PanelContent>
            <AxlPanel>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Internal ID`}</E.Label>
                  <E.Text>{_.defaultTo(activeShipment && activeShipment.internal_id, '-')}</E.Text>
                </AxlPanel.Col>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Tracking Code`}</E.Label>
                  <E.Text>{_.defaultTo(activeShipment && activeShipment.tracking_code, '-')}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Text_2>{`The label is ready. Click to download the label and make sure to apply to the parcel before pick-up.`}</E.Text_2>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row>
                <AxlPanel.Col center>
                  <AxlButton compact onClick={this.downloadLabel} style={styles.control_1} bg={`blueGrayMain`}>{`Download Label`}</AxlButton>
                </AxlPanel.Col>
              </AxlPanel.Row>
            </AxlPanel>
          </E.PanelContent>
          <AxlPanel.Row style={styles.row_3}>
            <AxlPanel.Col center>
              <AxlButton compact onClick={this.props.resetState} style={styles.control_1} bg={`borderBlueGrayMain`}>{`Add another shipment`}</AxlButton>
            </AxlPanel.Col>
          </AxlPanel.Row>
        </E.Panel>
       </E.StepContainer>);
  }
}

export default SingleOrderSubmitted;